import React from 'react';
import img1 from '../images/Admin.png';
import img2 from '../images/Customer.png';
import img3 from '../images/Supplier.jpg';
import LinkCard from '../components/Common/LinkCard';

const Homepage = () => {
    return (
        <>
            <div className="mt-2 px-5 pb-5 pt-1 bg-primary text-white rounded">
                <h1 className='display-4'>Stock Management System</h1>
                <p className="admin-home">Stock Management software tracks, manages, and organises stock levels, orders, sales and deliveries. The
                    purpose of stock management software is to maintain an optimal stock level, tracks goods during transport
                    between locations, receive new items, manage warehouse processes such as picking, packing, and shipping and 
                    ensure your products are never out of stock.
                </p>
            </div>
            <div className="home-page">
                <p className='display-6 text-center text-primary mb-4'>Explore sections</p>
                <div className="d-flex justify-content-center">
                    <div className="row">
                        <LinkCard imgsrc={img1} path="/admin" title="Admin" para="Explore admin section" />
                        <LinkCard imgsrc={img2} path="/customer/login" title="Customer" para="Explore Customer section" />
                        <LinkCard imgsrc={img3} path="/supplier/login" title="Supplier" para="Explore Supplier section" />
                    </div>
                </div>
            </div>
        </>
    );
};

export default Homepage;
